// extracted by mini-css-extract-plugin
export default {"moreStories":"moreStories-s0fae","contentGrid":"contentGrid-fUk4Z","regionInfo":"regionInfo-rQ0DI"};